import React from 'react';
import PropTypes from 'prop-types';
import { connectToStores } from 'fluxible-addons-react';
import styles from './styles.module.styl';
import DocumentStore from '../../../../stores/DocumentStore';
import Breadcrumbs from '../../../Breadcrumbs';

/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-danger */

const SearchResult = ({
  id,
  title,
  url,
  content,
  description,
  crumbs,
  isDocument,
  handleClick
}) => {
  const contentBody = description || content;

  return (
    <div className={styles.searchResult} onClick={e => handleClick({ e, id, url, isDocument })}>
      <h2 className={styles.title}>
        <a href={url}>{title}</a>
      </h2>
      {crumbs && <Breadcrumbs crumbs={crumbs} />}
      {contentBody && (
        <p className={styles.description}>
          <a href={url} dangerouslySetInnerHTML={{ __html: contentBody }} />
        </p>
      )}
    </div>
  );
};

SearchResult.propTypes = {
  id: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  isDocument: PropTypes.bool.isRequired,
  content: PropTypes.string,
  description: PropTypes.string,
  crumbs: PropTypes.array
};

SearchResult.contextTypes = {
  getStore: PropTypes.func,
  executeAction: PropTypes.func
};

export default connectToStores(SearchResult, [DocumentStore], (context, { url }) => {
  const doc = context.getStore(DocumentStore).getDocument(url);
  if (doc && doc.meta) {
    return {
      crumbs: doc.meta.breadcrumbs,
      description: doc.meta.description,
      url: doc.meta.url,
      isDocument: true
    };
  }

  return {
    isDocument: false
  };
});
